import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface CreatePostPayload {
	body: string;
	images?: string[];
	videos?: string[];
}

const createPost = async (payload: CreatePostPayload) => {
	const response = await cmsClient.post("/social-posts/", payload);
	return response.data;
};

const useCreatePost = () => {
	const queryClient = useQueryClient();

	return useMutation(createPost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useCreatePost;
